
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 10V9h4v1H2zM2 7v1h4V7H2zM2 6V5h4v1H2zM2 3v1h4V3H2zM7 10V9h4v1H7zM7 7v1h4V7H7zM7 3v3h4V3H7z","fill":"#000"}}),_c('path',{attrs:{"stroke":"#000","d":"M.5.5h12v12H.5z"}})])
          )
        }
      }
    